// 记录用keep-alive缓存的页面name
const aliveRouter = {
  state: {
    noAliveRouter: [],
    routeMatched: [], // 记录每次切换页面，最原始的this.router.matched,用于菜单的树分层
    aliveRouters: [{ name: 'RouteView' }] // 缓存页面路由,默认会缓存最外层的RouteView
  },
  mutations: {
    setAliveRouter(state, data) {
      if (data?.name) {
        const aliveRouterNameList = state.aliveRouters.map(value => value.name)
        // 不存在，则允许放到缓存里面
        if (!aliveRouterNameList.includes(data.name) && data.fullPath) {
          state.aliveRouters.push({ name: data.name, fullPath: data.fullPath, path: data.path })
        }
      }
    },
    // 清空缓存数据
    clearAliveRouter(state) {
      state.aliveRouters = [{ name: 'RouteView' }];
    },
    // 批量设置非缓存路由
    setNoAliveRouterList(state, data) {
      if(data?.length > 0) {
        data.forEach(v => {
          if (!state.noAliveRouter.includes(v)) {
            state.noAliveRouter.push(v)
          }
        })
      }
    },
    // 设置单个非缓存路由
    setNoAliveRouter(state, data) {
      if (!state.noAliveRouter.includes(data)) {
        state.noAliveRouter.push(data)
      }
    },
    // 删除单个非缓存路由
    clearItemNoAliveRouter(state, data) {
      const index = state.noAliveRouter.indexOf(data)
      if (index !== -1) {
        state.noAliveRouter.splice(index, 1)
      }
    },
    // 清空非缓存
    clearNoAliveRouter(state) {
      state.noAliveRouter = []
    },
    // 设置路由匹配
    setRouteMatched(state, data) {
      state.routeMatched = data || []
    },
    // 清空路由匹配
    clearRouteMatched(state) {
      state.routeMatched = []
    }
  }
}

export default aliveRouter
